module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_partners')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addCompany
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_partner')))])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name_of_partner')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.companies), function(company) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name_of_partner')
      }
    }, [_vm._v(_vm._s(company.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_name_of_partner')) + "\n                            ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                          ")])])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b587e38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyPayment/CompanyPayment.vue
// module id = 808
// module chunks = 0